var isDev = process.env.NODE_ENV != 'production'
class CbStorage {
  constructor() {
    try {
      window.localStorage;
      if (isDev) {
        this.localStorageEnabled = true;
        return;
      }
      if (window.initInfo) {
        if (!(window.initInfo.is_preview || !window.initInfo.sso_enabled)) {
          this.localStorageEnabled = true;
        }
      }
    } catch (error) {
      this.localStorageEnabled = false;
    }
  }


  setItem(key, value) {
    if (this.localStorageEnabled) {
      try {
        window.localStorage.setItem(key, value);
      } catch (error) {
        this.localStorageEnabled = false;
      }
    }
  }

  getItem(key) {
    if (this.localStorageEnabled) {
      return window.localStorage.getItem(key);
    }
  }

  removeItem(key) {
    if (this.localStorageEnabled) {
      window.localStorage.removeItem(key);
    }
  }

  isLocalStorageEnabled() {
    return this.localStorageEnabled;
  }
}

export default new CbStorage();


// WEBPACK FOOTER //
// ./src/utils/cb-storage.js